import { useSelector, useDispatch } from 'react-redux';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import { MAX_GENERATE_NUM } from '../../../config/dataConfig/FJImageToImageData';
import FJGenerateQuantity from './FJGenerateQuantity';
import useLocalStore from '../../../hooks/useLocalStore';

const FJGenerateQuantityContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();

    const generateQuantity = useSelector(state => state.imageToImage.generateQuantity);
    const changeGenerateQuantity = num => {
        dispatch(FJActionImageToImage.updateGenerateQuantityAction(num));
    };

    const _handleChangeGenerateNumber = value => {
        changeGenerateQuantity(value);
    };
    return (
        <FJGenerateQuantity
            generateQuantity={generateQuantity}
            handleChangeGenerateNumber={_handleChangeGenerateNumber}
        />
    );
};

export default FJGenerateQuantityContainer;
